import Class from '@/Class';
import ComponentManager from '@/Management/ComponentManager';
import ControlFactory from '@/Factories/ControlFactory';
import AssociationGridFactory from '@/Factories/ControlFactories/AssociationGridFactory';
import type DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import Utilities from '@/Utility/Utilities';

export default class AssociationHelper extends Class {
    public contextPdoId: string;
    public associationName: string;
    public pdTypeName: string;
    public affectedObjectIds: Array<string>;
    public confirmDeletionCallback: (boolean: boolean) => void;
    public state: KnockoutObservable<string>;

    public constructor(params: any) {
        super();

        this.contextPdoId = this.paramOrDefault(params.contextPdoId, -1);
        this.associationName = this.paramOrDefault(params.associationName, "");
        this.pdTypeName = this.paramOrDefault(params.pdTypeName, "");
        this.affectedObjectIds = this.paramOrDefault(params.affectedObjectIds, []);
        this.confirmDeletionCallback = this.handlerOrDefault(params.confirmDeletionCallback);
        /*
         * ObjectHelperState
         * 
         * Initialized = 1,
         * TryToDisconnectSent = 2,
         * AfterTryToDisconnect = 3,
         * GetResourcesForDeletionSent = 4,
         * AfterGetResourcesForDeletion = 5,
         * WaitingForDelete = 6,
         * TryToDeleteSent = 7,
         * AfterTryToDelete = 8,
         * Finished = 9
         */
        this.state = this.observableOrDefault(params.state, "Initialized");
    }

    public ExecuteCheck(): void {
        throw 'Function has to be Implemented';
    }

    public static activateDataLoading(context: DetailViewContext, membersToActivate: string[], skippedRelation: string = ''): void {
        membersToActivate.forEach((member) => {
            if (member == skippedRelation)
                return;

            const factory = context.getUIFactory<ControlFactory>(member);
            if (!Utilities.isNullOrUndefined(factory) && factory instanceof AssociationGridFactory && factory.isLazy && !factory.dataGrid.shouldLoadData()) {
                factory.dataGrid.shouldLoadData(true);
            }
        });
    }
}

ComponentManager.setUtility('ObjectCreationHelper', AssociationHelper, 'RADPresentation.HTMLClient.DefaultViewExtensions');